import { Box, Button, IconButton, styled, Typography } from '@mui/material';

export const BannerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isClosing',
})<{ isClosing?: boolean }>(({ isClosing }) => ({
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  padding: '1rem',
  paddingBottom: '1.25rem',
  background: '#F9FAFB',
  border: '1px solid #E5E7EB',
  borderRadius: '14px',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  minHeight: '12rem',
  overflow: 'visible',

  opacity: isClosing ? 0 : 1,
  transform: isClosing ? 'translateY(-10px)' : 'translateY(0)',
  transition: 'opacity 400ms ease-out, transform 400ms ease-out',
}));

export const BannerCloseButton = styled(IconButton)({
  position: 'absolute',
  top: '0.25rem',
  right: '0.25rem',
  transform: 'translate(50%, -50%)',
  zIndex: 1,
  width: '1.5rem',
  height: '1.5rem',
  padding: 0,
  backgroundColor: '#FFFFFF',
  border: '1px solid #E5E7EB',
  color: '#030712',

  '&:hover': {
    backgroundColor: '#FFFFFF',
  },
});

export const BannerBadge = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  minWidth: '5.5rem',
  borderRadius: '1.5rem',
  padding: '0.2rem 0.65rem',
  backgroundColor: '#AECBD0',
  color: '#1b2525',
  fontSize: '0.75rem',
  lineHeight: '1rem',
  fontWeight: 700,
});

export const BannerTitle = styled(Typography)({
  color: '#030712',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  fontWeight: 600,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitBoxPack: 'center',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexShrink: 0,
});

export const BannerDescription = styled(Typography)({
  color: '#030712',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  fontWeight: 400,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexShrink: 0,
});

export const BannerButton = styled(Button)({
  marginTop: 'auto',

  width: '100%',
  height: '2rem',
  minHeight: '2rem',
  padding: '0.5rem 0.75rem',

  flexShrink: 0,
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',

  backgroundColor: '#2F736E',
  color: '#F9FAFB',
  fontWeight: 500,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  borderRadius: '0.5rem',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#2F736E',
    boxShadow: 'none',
  },
});

export const BannerDots = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.4rem',
  marginTop: '0.25rem',
});

export const BannerDot = styled(Box)({
  width: '0.4rem',
  height: '0.4rem',
  borderRadius: '50%',
  backgroundColor: '#FFFFFF',
  border: '1px solid #6C7A78',
  transition: 'all 0.3s ease',
});

export const ActiveBannerDot = styled(Box)({
  width: '0.5rem',
  height: '0.5rem',
  borderRadius: '50%',
  backgroundColor: '#6C7A78',
  transition: 'all 0.3s ease',
});
